'use client';

import {useCallback, useContext} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns a stable function to imperatively read the full selected screen IDs
 * without subscribing to changes. Use in event handlers to avoid re-renders.
 * Stable as long as the provider is mounted (getSnapshot has [] deps).
 */
export function useGetSelectedScreenIds(): () => string[] {
  const {getSnapshot} = useContext(ActiveScreenIdSubscriptionContext);
  return useCallback(() => getSnapshot(), [getSnapshot]);
}
